
import { useEffect } from 'react';
import Navbar from '../home/components/Navbar';
import Hero from './components/Hero';
import Products from './components/Products';
import Benefits from './components/Benefits';
import BeforeAfter from './components/BeforeAfter';
import MyStory from './components/MyStory';
import Testimonials from './components/Testimonials';
import EbookSection from './components/EbookSection';
import FAQ from './components/FAQ';
import FinalCTA from './components/FinalCTA';
import StickyBar from './components/StickyBar';
import Footer from '../home/components/Footer';
import { trackViewContent } from '../../utils/metaPixel';

export default function BoutiquePage() {
  useEffect(() => {
    trackViewContent({
      content_name: 'Boutique - Soins Coréens',
      content_ids: ['boutique'],
      content_type: 'product_group',
      content_category: 'Skincare',
    });
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <Products />
      <Benefits />
      <BeforeAfter />
      <MyStory />
      <Testimonials />
      <EbookSection />
      <FAQ />
      <FinalCTA />
      <StickyBar />
      <Footer />
    </div>
  );
}
